"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/InsertVariableMenu.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _broadcastTemplate = require('shared/services/broadcastTemplate');
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _noAutofill = require('web/screens/Broadcast/Wizard/Recipients/noAutofill');








const NEXT = {
  ArrowDown: (i, n) => (i + 1) % n,
  ArrowUp: (i, n) => (i - 1 + n) % n,
  Home: () => 0,
  End: (_, n) => n - 1,
}

/* Rev 19 I1: "Insert variable" lists the campaign's declared variables and
 * inserts the picked one at the cursor. Rev 24 M1: the patient's First name
 * and Last name come first, always. It only inserts: variables come from
 * a CSV or + Add variable in the recipients table (M3).
 * Review R800-7: opened from the keyboard (Enter, Space or ArrowDown) it
 * focuses its first item; arrows, Home and End move through the items, and
 * Escape returns focus to the trigger. A mouse click leaves focus (and the
 * caret) in the message.
 * Rev 35 E4: First name and Last name take an optional "Fallback if blank",
 * inserted as {{first_name | there}}. */
const InsertVariableMenu = ({ fields, onInsert }) => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  const [isFocusingFirst, setIsFocusingFirst] = _react.useState.call(void 0, false)
  const [fallback, setFallback] = _react.useState.call(void 0, '')
  const isBadFallback = _broadcastTemplateTokens.INVALID_DEFAULT.test(fallback)
  const ref = _react.useRef(null)
  const triggerRef = _react.useRef(null)
  const items = () => Array.from(_nullishCoalesce(_optionalChain([ref, 'access', _2 => _2.current, 'optionalAccess', _3 => _3.querySelectorAll, 'call', _4 => _4('[role="menuitem"]')]), () => ( [])))

  const openByKeyboard = () => {
    setIsOpen(true)
    setIsFocusingFirst(true)
  }
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen || !isFocusingFirst) return
      setIsFocusingFirst(false)
      _optionalChain([items, 'call', _5 => _5(), 'access', _6 => _6[0], 'optionalAccess', _7 => _7.focus, 'call', _8 => _8()])
    },
    [isOpen, isFocusingFirst],
  )

  const onMenuKeyDown = (e) => {
    // Keys typed in the fallback field stay there.
    if (e.target instanceof HTMLInputElement) return
    const next = NEXT[e.key]
    const list = items()
    if (!next || !list.length) return
    e.preventDefault()
    const current = list.indexOf(document.activeElement )
    _optionalChain([list, 'access', _9 => _9[next(current < 0 ? -1 : current, list.length)], 'optionalAccess', _10 => _10.focus, 'call', _11 => _11()])
  }

  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      const onKey = (e) => {
        if (e.key !== 'Escape') return
        if (_optionalChain([ref, 'access', _12 => _12.current, 'optionalAccess', _13 => _13.querySelector, 'call', _14 => _14('[role="menu"]'), 'optionalAccess', _15 => _15.contains, 'call', _16 => _16(document.activeElement)])) _optionalChain([triggerRef, 'access', _17 => _17.current, 'optionalAccess', _18 => _18.focus, 'call', _19 => _19()])
        setIsOpen(false)
      }
      const onDown = (e) => {
        if (ref.current && !ref.current.contains(e.target )) setIsOpen(false)
      }
      document.addEventListener('keydown', onKey)
      document.addEventListener('mousedown', onDown)
      return () => {
        document.removeEventListener('keydown', onKey)
        document.removeEventListener('mousedown', onDown)
      }
    },
    [isOpen],
  )

  // A built-in name can't be a campaign variable; never list it twice.
  const csvFields = fields.filter(f => !_broadcastTemplate.isBuiltInVariable.call(void 0, f.Name))
  const item = (name, source) => (
    _react2.default.createElement('button', {
      key: name,
      type: "button",
      role: "menuitem",
      className: "broadcast-insert--item",
      disabled: _broadcastTemplate.isBuiltInVariable.call(void 0, name) && isBadFallback,
      onMouseDown: e => e.preventDefault(),
      onClick: () => {
        setIsOpen(false)
        setFallback('')
        onInsert(name, _broadcastTemplate.isBuiltInVariable.call(void 0, name) && fallback.trim() ? fallback.trim() : null)
      }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}

      , _react2.default.createElement('span', { className: "broadcast-insert--token", __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}, `{{${name}}}`)
      ,  source && _react2.default.createElement('span', { className: "broadcast-insert--source", __self: this, __source: {fileName: _jsxFileName, lineNumber: 104}},  source ) 
    )
  )
  return (
    _react2.default.createElement('div', { ref: ref, className: "broadcast-insert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 108}}
      , _react2.default.createElement('button', {
        ref: triggerRef,
        type: "button",
        className: _classBuilder2.default.call(void 0, 'broadcast-insert--toggle', isOpen && 'broadcast-insert--toggle--open'),
        'aria-haspopup': "menu",
        'aria-expanded': isOpen,
        // Keep the caret where it is in the message.
        onMouseDown: e => e.preventDefault(),
        onClick: e => {
          // detail is 0 for a click from Enter or Space.
          if (!isOpen && e.detail === 0) openByKeyboard()
          else setIsOpen(o => !o)
        },
        onKeyDown: e => {
          if (e.key !== 'ArrowDown') return
          e.preventDefault()
          openByKeyboard()
        }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}

        , _react2.default.createElement('span', { className: "broadcast-insert--braces", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, '{ }'), "Insert variable"

      )
      ,  isOpen && (
        _react2.default.createElement('div', { role: "menu", 'aria-label': "Variables", className: "broadcast-insert--menu", onKeyDown: onMenuKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}
          /* Rev 24 M1: the patient's own fields first, then the campaign's. */
          , _react2.default.createElement('div', { role: "group", 'aria-label': "Patient", className: "broadcast-insert--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 134}}
            , _react2.default.createElement('p', { className: "broadcast-insert--group-label", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}, "Patient")
            ,  _broadcastTemplate.BUILT_IN_TEMPLATE_VARIABLES.map(b => item(b.Name, b.Label)) 
            , _react2.default.createElement('label', { className: "broadcast-insert--fallback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 137}}
              , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, "Fallback if blank"  )
              , _react2.default.createElement('input', {
                className: "blm-text-input",
                placeholder: "Optional, like there"  ,
                ..._noAutofill.NO_AUTOFILL,
                value: fallback,
                onChange: e => setFallback(e.target.value), __self: this, __source: {fileName: _jsxFileName, lineNumber: 139}}
              )
            )
            ,  isBadFallback && (
              _react2.default.createElement('p', { role: "alert", className: "broadcast-insert--fallback-error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}, "A fallback can't contain "    , '{', " or "  , '}')
            )
          )
          , _react2.default.createElement('div', { role: "group", 'aria-label': "From recipients" , className: "broadcast-insert--group", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
            , _react2.default.createElement('p', { className: "broadcast-insert--group-label", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, "From recipients" )
            ,  csvFields.length > 0
              ? csvFields.map(f => item(f.Name, f.Source && f.Source !== f.Name ? f.Source : null))
              : (
                  _react2.default.createElement('p', { className: "broadcast-insert--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}, "No CSV variables yet. Add recipients from a CSV, or use + Add variable in the recipients table."

                  )
                )
            
          )
        )
      )
    )
  )
}

exports. default = InsertVariableMenu
